"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.defaultClusteringOptions = void 0;
var react_1 = require("react");
var context_1 = require("./context");
var get_marker_icon_1 = __importDefault(require("./utils/get-marker-icon"));
exports.defaultClusteringOptions = {
    /**
     * Maximum radius of the neighborhood.
     */
    eps: 32,
    /**
     * Minimum weight of points required to form a cluster (default weight for a cluster point is 1).
     */
    minWeight: 2
};
function createTheme(getBitmapForCluster, getBitmapForPoint) {
    return {
        getClusterPresentation: function (cluster) {
            var clusterPoints = [];
            cluster.forEachDataPoint(function (point) { return clusterPoints.push(point.getData()); });
            return new H.map.Marker(cluster.getPosition(), {
                data: clusterPoints,
                icon: (0, get_marker_icon_1["default"])(getBitmapForCluster(clusterPoints)),
                max: cluster.getMaxZoom(),
                min: cluster.getMinZoom()
            });
        },
        getNoisePresentation: function (point) {
            var data = point.getData();
            return new H.map.Marker(point.getPosition(), {
                data: data,
                icon: (0, get_marker_icon_1["default"])(getBitmapForPoint(data)),
                min: point.getMinZoom()
            });
        }
    };
}
function pointToDatapoint(point) {
    return new H.clustering.DataPoint(point.lat, point.lon, null, point.data);
}
/**
 * A component that can automatically cluster a group of datapoints.
 */
function Cluster(_a) {
    var points = _a.points, _b = _a.clusteringOptions, clusteringOptions = _b === void 0 ? exports.defaultClusteringOptions : _b, getBitmapForCluster = _a.getBitmapForCluster, getBitmapForPoint = _a.getBitmapForPoint, onClusterClick = _a.onClusterClick, onPointClick = _a.onPointClick;
    var map = (0, react_1.useContext)(context_1.HEREMapContext).map;
    var onClusterClickRef = (0, react_1.useRef)(onClusterClick);
    onClusterClickRef.current = onClusterClick;
    var onPointClickRef = (0, react_1.useRef)(onPointClick);
    onPointClickRef.current = onPointClick;
    var theme = (0, react_1.useMemo)(function () { return createTheme(getBitmapForCluster, getBitmapForPoint); }, [getBitmapForCluster, getBitmapForPoint]);
    var datapoints = (0, react_1.useMemo)(function () { return points.map(pointToDatapoint); }, [points]);
    var onClick = (0, react_1.useCallback)(function (evt) {
        var e = evt;
        var data = e.target.getData();
        if (Array.isArray(data)) {
            onClusterClickRef.current(data, e);
        }
        else {
            onPointClickRef.current(data, e);
        }
    }, []);
    var clusteredDataProvider = (0, react_1.useMemo)(function () {
        var provider = new H.clustering.Provider(datapoints, {
            clusteringOptions: clusteringOptions,
            theme: theme
        });
        provider.addEventListener("tap", onClick);
        return provider;
    }, [clusteringOptions, onClick /* theme, datapoints */]);
    (0, react_1.useEffect)(function () {
        clusteredDataProvider.setTheme(theme);
    }, [theme, clusteredDataProvider]);
    (0, react_1.useEffect)(function () {
        clusteredDataProvider.setDataPoints(datapoints);
    }, [datapoints, clusteredDataProvider]);
    (0, react_1.useEffect)(function () {
        var layer = new H.map.layer.ObjectLayer(clusteredDataProvider);
        map === null || map === void 0 ? void 0 : map.addLayer(layer);
        return function () {
            map === null || map === void 0 ? void 0 : map.removeLayer(layer);
        };
    }, [map, clusteredDataProvider]);
    return null;
}
exports["default"] = Cluster;
